import { z } from "zod";

export const contactFormSchema = z.object({
  name: z.string().min(2, { message: "Name must be at least 2 characters" }),
  email: z.string().email({ message: "Invalid email address" }),
  phone: z.string().refine(val => val === "" || val.length >= 6, {
    message: "Phone number must be at least 6 characters"
  }).optional(),
  company: z.string().min(1, { message: "Company name is required" }),
  requirements: z.string().min(5, { message: "Requirements must be at least 5 characters" }),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;

export const consultationFormSchema = z.object({
  name: z.string().min(2, { message: "Name must be at least 2 characters" }),
  email: z.string().email({ message: "Invalid email address" }),
  phone: z.string().refine(val => val === "" || val.length >= 6, {
    message: "Phone number must be at least 6 characters"
  }).optional(),
  company: z.string().min(1, { message: "Company name is required" }),
  projectScope: z.string().min(5, { message: "Project scope must be at least 5 characters" }),
  selectedService: z.string().min(1, { message: "Technical domain is required" }),
});

export type ConsultationFormData = z.infer<typeof consultationFormSchema>;

export const newsletterSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
});

export type NewsletterData = z.infer<typeof newsletterSchema>;
